import {PlusIcon} from '@web/assets/icons';
import {Button, Tooltip} from 'antd';
import AddTrigger from '../AddJob';

export const AddJobButton = (props) => {
  return <div>
    <div style={{width: "100%", height: 60}} />
    <Tooltip
      title={<div><AddTrigger onAdd={props.onAdd} /></div>}
      trigger={["click"]}
    >
      <Button block size="large" shape="round" className="space space-center-y space-center-x rounded" style={{padding: "10px 0", backgroundColor: "#0e161f", border: "dashed 1px rgba(255, 255, 255, 0.1)"}}><PlusIcon /> Add job</Button>
    </Tooltip>
  </div>
}
